module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row8_certificate.44eaff78.png";